export default {
    state: {
        endpoint: "gocontact",
    },
    getters: {
        endpoint: (state) => state.endpoint,
    },
    mutations: {
    },
    actions: {
        colgarLlamada({state},payload) {
            this.dispatch('index',  {endpoint: state.endpoint+'/colgar', params: payload})
            .then(response => {
                console.log("correcto",response)
            })
            .catch(error => {
                console.log("error--",error)
            })
        }
    }
}